import HomePageHeading from "./HomePageHeading"
export default HomePageHeading
